"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var MoreTableData = function MoreTableData(_ref) {
  var record = _ref.record;
  return /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 11,
    className: "m-1"
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    style: {
      height: "auto"
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    size: "small",
    bordered: true,
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "CL Code",
    text: "center",
    span: 2
  }, record.CL_code)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Active Student",
    span: 2
  }, record.ActiveParents)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Dropout Student",
    span: 2
  }, record.DropoutParent)))))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12,
    className: "m-1"
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    style: {
      height: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Forms Fill Next Day",
    span: 2
  }, record.FormsFillNextDay)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Late in Training",
    span: 2
  }, record.Late_in_Training)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "What RM Does",
    span: 2
  }, record.WhatRMDoes)))))));
};

var _default = MoreTableData;
exports.default = _default;